import { Text, View } from '@react-pdf/renderer'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { DICTIONARY } from '../../../constants/dictionary'
import { Entry } from '../../../model/Entry'
import { iGen } from '../../../utils/indexGen'
import { pdfDocStyles } from '../PDFDocument'

interface Props {
  serviceDetails: Entry[]
  parentStyles: typeof pdfDocStyles
}

const ServiceDetailsSection: React.FC<Props> = ({
  serviceDetails,
  parentStyles,
}) => {
  const { t } = useTranslation()
  return (
    !!serviceDetails.length && (
      <View wrap={false}>
        <Text style={parentStyles.subTitle}>
          {t(DICTIONARY.QUOTE_SUMMARY_SERVICES_LABEL)}
        </Text>
        {serviceDetails.map((service, index) => (
          <View style={parentStyles.row} key={iGen(index)}>
            <Text style={parentStyles.wideValue}>{service.description}</Text>
          </View>
        ))}
      </View>
    )
  )
}

export default ServiceDetailsSection
